import React, {Component} from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import ModalComponent from  '../../../components/ModalComponent';
import { FaShoppingCart } from "react-icons/fa";
import { Card, CardBody, Table } from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ListOrderComponent from "../../../components/Admin/orders/ListOrderComponent";
import PaginateComponent from "../../../components/PaginateComponent";

class ListOrderPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listOrder: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            userId: 0,
            typeOrder: '',
            className: ''
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListOrder();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getListOrder = () => {
        this.setState({
            isLoading: true,
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = "?userId=" + this.state.userId + "&typeOrder=" + this.state.typeOrder;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/getListOrder' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listOrder: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn hàng thất bại',
                })
            })
    }

    changeQtt = (event) => {
        this.setState({
            userId: event.target.value
        })
        this.getListOrder();
    }

    // changeTypeOrder = (event) => {
    //     // console.log(event.target.value)
    //     this.search({
    //         typeOrder: event.target.value
    //     })
    //     this.getListOrder();
    // }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        let data = "?userId=" + this.state.userId + "&typeOrder=" + this.state.typeOrder + "&page=" + page;
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/order/getListOrder' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoading: false
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listOrder: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu đơn hàng thất bại',
                })
            })
    }

    screentListOrder = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listOrder.length ) {
                return (
                    this.state.listOrder.map( (order, key) => {
                        return (
                            <ListOrderComponent
                                key={key}
                                order={order}
                                actionKey={key}
                                showModal = { (actionKey, action) => this.showModal(actionKey, action) }
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có đơn hàng trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    showModal = (actionKey, action) => {
        let titleModal;
        let modalBody;
        let className = '';
        if ( action === 'infoOrder' ) {
            titleModal = 'Chi tiết đơn dặt hàng';
            modalBody = this.modalBody(actionKey, action);
            className = 'modal-xl';
        }
        else if ( action === 'deleteOrder' ) {
            titleModal = 'Xóa đơn dặt hàng';
            modalBody = this.modalBody(actionKey, action);
        }
        else if ( action === 'cancelOrder' ) {
            titleModal = 'Yêu cầu hủy đơn dặt hàng';
            modalBody = this.modalBody(actionKey, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            actionKey: actionKey,
            className: className
        })
    }

    hiddenModal = () => {
        this.setState({
            actionKey: 0,
            action: '',
            isModal: false,
        })
    }

    modalBody = (actionKey, action) => {
        if ( action === 'deleteOrder' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa đơn đặt hàng này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này rất nguy hiểm, có thể xóa tất cả dữ liệu về đơn hàng này và xóa các dịch vụ có trong đơn hàng. Vui lòng kiểm tra lại.
                    </span>
                </div>
            )
        }
        else if ( action === 'cancelOrder' ) {
            return (
                <div className="text-center">
                    Bạn có muốn yêu cầu hủy đơn đặt hàng này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này rất nguy hiểm, có thể xóa tất cả dữ liệu về đơn hàng này và xóa các dịch vụ có trong đơn hàng. Vui lòng kiểm tra lại.
                    </span>
                </div>
            )
        }
        else if ( action === 'infoOrder' ) {
            return (
                <>
                    <div className="detail_order text-center">
                        <div className="paid">
                            { this.loadStatusOrder(actionKey) }
                        </div>
                        <div className="date_due">
                            Ngày đặt hàng: <b>{ this.state.listOrder[actionKey].text_date_create }</b>
                        </div>
                        <div className="date_due">
                            {
                                this.state.listOrder[actionKey].status === 'Finish'
                                || this.state.listOrder[actionKey].status === 'Waiting' ? (
                                    <div className="text-success">
                                        Ngày thanh toán: <b>{ this.state.listOrder[actionKey].text_date_paid }</b>
                                    </div>
                                ) : (
                                    <div className="text-danger">
                                        Chưa thanh toán
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div className="detail_order">
                        <div>Thông tin dịch vụ / sản phẩm</div>
                        <div className="m-3">
                            <Table className="table table-bordered table-hover rounded text-center">
                                <thead className="primay">{ this.loadHeadInfoOrder( actionKey  ) }</thead>
                                <tbody>{ this.loadBodyInfoOrder(actionKey) }</tbody>
                            </Table>
                        </div>
                    </div>
                </>
            )
        }
    }

    loadStatusOrder = (actionKey) => {
        if ( this.state.listOrder[actionKey].status === 'Finish' ) {
            return (
                <span className="text-success">Đã thanh toán</span>
            )
        }
        else if ( this.state.listOrder[actionKey].status === 'Waiting' ) {
            return (
                <span className="text-info">Thanh toán chờ</span>
            )
        }
        else if ( this.state.listOrder[actionKey].status === 'Pending' ) {
            return (
                <span className="text-danger">Chưa thanh toán</span>
            )
        }
        else if ( this.state.listOrder[actionKey].status === 'Cancel' ) {
            return (
                <span className="text-danger">Hủy</span>
            )
        }
    }

    loadHeadInfoOrder = (actionKey) => {
        if (
            this.state.listOrder[actionKey].type_order === "order_vps_us" || this.state.listOrder[actionKey].type_order === "order_vps"
            || this.state.listOrder[actionKey].type_order === "order_cloud_server"
        ) {
            return (
                <>
                    <th>Tên khách hàng</th>
                    <th>Dịch vụ</th>
                    <th>Cấu hình</th>
                    <th>Thời gian thuê</th>
                    <th>Ngày đặt hàng</th>
                    <th>Giá</th>
                </>
            )
        }
        else if (
            this.state.listOrder[actionKey].type_order === "expire_vps" || this.state.listOrder[actionKey].type_order === "expire_vps_us"
            || this.state.listOrder[actionKey].type_order === "expire_cloud_server"
        ) {
            return (
                <>
                    <th>Tên khách hàng</th>
                    <th>Dịch vụ</th>
                    <th>Cấu hình</th>
                    <th>Thời gian thuê</th>
                    <th>Ngày đặt hàng</th>
                    <th>Giá</th>
                </>
            )
        }
        else if ( this.state.listOrder[actionKey].type_order === 'order_hosting_cpanel' ) {
            return (
                <>
                    <th>Tên khách hàng</th>
                    <th>Dịch vụ</th>
                    <th>Sản phẩm</th>
                    <th>Thời gian thuê</th>
                    <th>Ngày đặt hàng</th>
                    <th>Giá</th>
                </>
            )
        }
        else if ( this.state.listOrder[actionKey].type_order === 'expire_hosting_cpanel' ) {
            return (
                <>
                    <th>Tên khách hàng</th>
                    <th>Dịch vụ</th>
                    <th>Sản phẩm</th>
                    <th>Thời gian thuê</th>
                    <th>Ngày đặt hàng</th>
                    <th>Giá</th>
                </>
            )
        }
        else if ( this.state.listOrder[actionKey].type_order === 'upgrade' ) {
            return (
                <>
                    <th>Tên khách hàng</th>
                    <th>Dịch vụ</th>
                    <th>Sản phẩm</th>
                    <th>Ngày đặt hàng</th>
                    <th>Giá</th>
                </>
            )
        }
        else if ( this.state.listOrder[actionKey].type_order === 'addon_vps' || this.state.listOrder[actionKey].type_order === 'addon_cloud_server' ) {
            return (
                <>
                    <th>Tên khách hàng</th>
                    <th>Dịch vụ</th>
                    <th>CPU</th>
                    <th>RAM</th>
                    <th>DISK</th>
                    <th>Ngày đặt hàng</th>
                    <th>Giá</th>
                </>
            )
        }
        else if ( this.state.listOrder[actionKey].type_order === "order_proxy" ) {
            return (
                <>
                    <th>Tên khách hàng</th>
                    <th>Dịch vụ</th>
                    <th>Loại</th>
                    <th>Thời gian thuê</th>
                    <th>Ngày đặt hàng</th>
                    <th>Giá</th>
                </>
            )
        }
        else if ( this.state.listOrder[actionKey].type_order === "expire_proxy" ) {
            return (
                <>
                    <th>Tên khách hàng</th>
                    <th>Dịch vụ</th>
                    <th>Thời gian thuê</th>
                    <th>Ngày đặt hàng</th>
                    <th>Giá</th>
                </>
            )
        }
    }

    loadBodyInfoOrder = (actionKey) => {
        if (
            this.state.listOrder[actionKey].type_order === "order_vps_us" || this.state.listOrder[actionKey].type_order === "order_vps"
            || this.state.listOrder[actionKey].type_order === "order_cloud_server" || this.state.listOrder[actionKey].type_order === "order_nat_vps"
        ) {
            return (
                this.state.listOrder[actionKey].vps.map( (vps, key) => (
                    <tr key={key}>
                        <td>
                            <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.state.listOrder[actionKey].user_id}>{this.state.listOrder[actionKey].text_user_name}</Link>
                        </td>
                        <td>
                            Tạo VPS - { vps.ip }
                        </td>
                        <td>
                            { vps.text_config }
                        </td>
                        <td>
                            { vps.text_billing_cycle }
                        </td>
                        <td>
                            { this.state.listOrder[actionKey].text_date_create }
                        </td>
                        <td>
                            { this.addCommas(this.state.listOrder[actionKey].total / this.state.listOrder[actionKey].quantity) }
                        </td>
                    </tr>
                ))
            )
        }
        else if ( this.state.listOrder[actionKey].type_order === 'order_hosting_cpanel' ) {
            return (
                this.state.listOrder[actionKey].hostings.map( (vps, key) => (
                    <tr key={key}>
                        <td>
                            <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.state.listOrder[actionKey].user_id}>{this.state.listOrder[actionKey].text_user_name}</Link>
                        </td>
                        <td>
                            Tạo Hosting - { vps.domain }
                        </td>
                        <td>
                            { vps.text_config }
                        </td>
                        <td>
                            { vps.text_billing_cycle }
                        </td>
                        <td>
                            { this.state.listOrder[actionKey].text_date_create }
                        </td>
                        <td>
                            { this.addCommas(this.state.listOrder[actionKey].total / this.state.listOrder[actionKey].quantity) }
                        </td>
                    </tr>
                ))
            )
        }
        else if ( this.state.listOrder[actionKey].type_order === 'addon_vps' || this.state.listOrder[actionKey].type_order === 'addon_cloud_server' ) {
            return (
                <tr>
                    <td>
                        <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.state.listOrder[actionKey].user_id}>{this.state.listOrder[actionKey].text_user_name}</Link>
                    </td>
                    <td>
                        Nâng cấp VPS - { this.state.listOrder[actionKey].vpsIp }
                    </td>
                    <td>
                        { this.state.listOrder[actionKey].order_addon_vps.cpu } Cores
                    </td>
                    <td>
                        { this.state.listOrder[actionKey].order_addon_vps.ram } GB
                    </td>
                    <td>
                        { this.state.listOrder[actionKey].order_addon_vps.disk } GB
                    </td>
                    <td>
                        { this.state.listOrder[actionKey].text_date_create }
                    </td>
                    <td>
                        { this.addCommas(this.state.listOrder[actionKey].total / this.state.listOrder[actionKey].quantity) }
                    </td>
                </tr>
            )
        }
        else if ( this.state.listOrder[actionKey].type_order === 'upgrade' ) {
            return (
                <tr>
                    <td>
                        <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.state.listOrder[actionKey].user_id}>{this.state.listOrder[actionKey].text_user_name}</Link>
                    </td>
                    <td>
                        Nâng cấp VPS - { this.state.listOrder[actionKey].hostingDomain }
                    </td>
                    <td>
                        { this.state.listOrder[actionKey].productUpgrade }
                    </td>
                    <td>
                        { this.state.listOrder[actionKey].text_date_create }
                    </td>
                    <td>
                        { this.addCommas(this.state.listOrder[actionKey].total / this.state.listOrder[actionKey].quantity) }
                    </td>
                </tr>
            )
        }
        else if (
            this.state.listOrder[actionKey].type_order === "expire_vps" || this.state.listOrder[actionKey].type_order === "expire_vps_us"
            || this.state.listOrder[actionKey].type_order === "expire_cloud_server"
        ) {
            return (
                this.state.listOrder[actionKey].order_expireds.map( (order_expired, key) => (
                    <tr key={key}>
                        <td>
                            <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.state.listOrder[actionKey].user_id}>{this.state.listOrder[actionKey].text_user_name}</Link>
                        </td>
                        <td>
                            Gia hạn VPS - { order_expired.vps.ip }
                        </td>
                        <td>
                            { order_expired.vps.text_config }
                        </td>
                        <td>
                            { order_expired.text_billing_cycle }
                        </td>
                        <td>
                            { this.state.listOrder[actionKey].text_date_create }
                        </td>
                        <td>
                            { this.addCommas(this.state.listOrder[actionKey].total / this.state.listOrder[actionKey].quantity) }
                        </td>
                    </tr>
                ))
            )
        }
        else if (
            this.state.listOrder[actionKey].type_order === "expire_hosting_cpanel"
        ) {
            return (
                this.state.listOrder[actionKey].order_expireds.map( (order_expired, key) => (
                    <tr key={key}>
                        <td>
                            <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.state.listOrder[actionKey].user_id}>{this.state.listOrder[actionKey].text_user_name}</Link>
                        </td>
                        <td>
                            Gia hạn Hosting - { order_expired.hosting.domain }
                        </td>
                        <td>
                            { order_expired.hosting.text_config }
                        </td>
                        <td>
                            { order_expired.text_billing_cycle }
                        </td>
                        <td>
                            { this.state.listOrder[actionKey].text_date_create }
                        </td>
                        <td>
                            { this.addCommas(this.state.listOrder[actionKey].total / this.state.listOrder[actionKey].quantity) }
                        </td>
                    </tr>
                ))
            )
        }
        else if ( this.state.listOrder[actionKey].type_order === 'order_proxy' ) {
            return (
                this.state.listOrder[actionKey].proxies.map( (vps, key) => (
                    <tr key={key}>
                        <td>
                            <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.state.listOrder[actionKey].user_id}>{this.state.listOrder[actionKey].text_user_name}</Link>
                        </td>
                        <td>
                            Tạo Proxy - { vps.ip }:{ vps.port }
                        </td>
                        <td>
                            { vps.text_config }
                        </td>
                        <td>
                            { vps.text_billing_cycle }
                        </td>
                        <td>
                            { this.state.listOrder[actionKey].text_date_create }
                        </td>
                        <td>
                            { this.addCommas(this.state.listOrder[actionKey].total / this.state.listOrder[actionKey].quantity) }
                        </td>
                    </tr>
                ))
            )
        }
        else if (
            this.state.listOrder[actionKey].type_order === "expire_proxy"
        ) {
            return (
                this.state.listOrder[actionKey].order_expireds.map( (order_expired, key) => (
                    <tr key={key}>
                        <td>
                            <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.state.listOrder[actionKey].user_id}>{this.state.listOrder[actionKey].text_user_name}</Link>
                        </td>
                        <td>
                            Gia hạn Proxy - { order_expired.proxy.ip }
                        </td>
                        <td>
                            { order_expired.text_billing_cycle }
                        </td>
                        <td>
                            { this.state.listOrder[actionKey].text_date_create }
                        </td>
                        <td>
                            { this.addCommas(this.state.listOrder[actionKey].total / this.state.listOrder[actionKey].quantity) }
                        </td>
                    </tr>
                ))
            )
        }
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    confirmModal = () => {
        if ( this.state.action === 'infoOrder' ) {
            this.hiddenModal();
        }
        else {
            this.setState({
                btnConfirmDisabled: true,
                isSpinner: true,
                isBtnConfirm: false,
                alert: {
                    error: false,
                    message: ''
                }
            })

            let form = {
                orderId: this.state.listOrder[ this.state.actionKey ],
                action: this.state.action
            }
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            axios.put( process.env.REACT_APP_API_URL + '/api/admin/order/action', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error > 9000 ) {
                        this.setState({
                            isSpinner: false,
                        });
                        this.props.logOut();
                    }
                    else {
                        if ( !ref.data.error ) {
                            this.getListOrder();
                        }
                        this.setState({
                            isSpinner: false,
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    this.setState({
                        isSpinner: false,
                        contentModal: {
                            title: this.state.contentModal.title,
                            modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                        },
                    })
                })
        }
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Quản lý đơn hàng"} page={"Đơn hàng"} icon={<FaShoppingCart className="breadcrumb-icon"/>} />
                            <Card>
                                <CardBody className="table-responsive">
                                    {/*<div className="col-12">*/}
                                    {/*    <Link className="btn btn-success" to="/admin/don-dat-hang/tao-don-hang">*/}
                                    {/*        Tạo đơn hàng*/}
                                    {/*    </Link>*/}
                                    {/*</div>*/}
                                    <div className="dataTables_wrapper form-inline dt-bootstrap">
                                        <div className="list-group-email row">
                                            <div className="col-md-12">
                                                {
                                                    this.checkNotification()
                                                }
                                            </div>
                                            <div className="col col-md-12">
                                                <Table className="table-sm table-bordered table-hover rounded table-list">
                                                    <thead className="primary">
                                                        <tr>
                                                            <th>Ngày đặt hàng</th>
                                                            <th>Khách hàng</th>
                                                            <th>Tổng tiền</th>
                                                            <th>Loại</th>
                                                            <th>Chi tiết</th>
                                                            <th>Trạng thái</th>
                                                            <th>Hành động</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        { this.screentListOrder() }
                                                    </tbody>
                                                </Table>
                                                { this.paginate() }
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                                className={this.state.className}
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminOrder' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListOrderPage);